import React from 'react'
import Visualization from 'platopulse/visualizations/components/Visualization'

import { normal } from 'platopulse/lib/colors'

const Histogram = ({ histogram, color, showAxis }) =>
    <Visualization
        className="full-height"
        rawSeries={[
            {
                card: {
                    display: "bar",
                    visualization_settings: {
                        "graph.colors": color,
                        "graph.x_axis.axis_enabled": showAxis,
                        "graph.x_axis.labels_enabled": showAxis,
                        "graph.y_axis.axis_enabled": showAxis,
                        "graph.y_axis.labels_enabled": showAxis
                    }
                },
                data: {
                    ...histogram,
                    rows: histogram.rows.map(row => [row[0], row[1] * 100])
                }
            }
        ]}
        showTitle={false}
    />

Histogram.defaultProps = {
    color: [normal.blue],
    showAxis: true
}

export default Histogram




// WEBPACK FOOTER //
// ./xray/Histogram.jsx